import axios from "../assets/api/serve.js";

//登录,获取token
export function getToken(params)
{
	return axios({
          headers: {
            Authorization: "Basic dGVzdDp0ZXN0"
          },
          url: "/auth/oauth/token",
          method: "POST",
          params: params
        })	
}

//初始化登录
export function loginInfo(params)
{
	return axios.get("/admin/user/loginInfo",{
		headers: {
		    Authorization:
		      localStorage.getItem("token_type") +
		      localStorage.getItem("access_token")
		}
	})
}